import React from 'react'
import Button from 'components/Button'

export default function TWControlsButton(props) {
	const { text, size, color, variant, onClick, disabled, ...other } = props

	return (
		<Button
			size={size || 'medium'}
			color={color || 'primary'}
			variant={variant || 'primary'}
			isOutline={variant === 'outlined'}
			disabled={disabled}
			onClick={onClick}
		>
			{text}
		</Button>
	)
}
